import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm5.266 6.188a6.607 6.607 0 0 0-3.751.363 6.484 6.484 0 0 0-2.107 1.38A6.366 6.366 0 0 0 3.001 16L2 15.59a7.43 7.43 0 0 1 1.643-2.414 7.57 7.57 0 0 1 2.458-1.611m0 0a7.705 7.705 0 0 1 4.376-.423 7.63 7.63 0 0 1 3.88 2.035A7.43 7.43 0 0 1 16 15.591L15 16a6.368 6.368 0 0 0-1.408-2.067 6.542 6.542 0 0 0-3.326-1.745",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }